import { lazy } from 'react';

// Lazy load components for better performance
const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));
const Music = lazy(() => import('../pages/music/Music'));
const Users = lazy(() => import('../pages/users/Users'));
const Playlists = lazy(() => import('../pages/playlists/Playlists'));
const PlaylistEdit = lazy(() => import('../pages/playlists/PlaylistEdit'));
const Schedules = lazy(() => import('../pages/schedules/Schedules'));
const Login = lazy(() => import('../pages/auth/Login'));

// Route configuration
export const routes = [
  // Public routes
  {
    path: '/login',
    element: Login,
    isPublic: true,
    requiresGuest: true, // Only accessible when not logged in
  },
  
  // Protected routes
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    element: Dashboard,
    requiresAuth: true,
    roles: ['admin', 'user'],
    title: 'Bảng điều khiển',
  },
  {
    path: '/music',
    element: Music,
    requiresAuth: true,
    roles: ['admin', 'user'],
    title: 'Quản lý nhạc',
  },
  {
    path: '/playlists',
    element: Playlists,
    requiresAuth: true,
    roles: ['admin', 'user'],
    title: 'Danh sách phát',
  },
  {
    path: '/playlists/:id/edit',
    element: PlaylistEdit,
    requiresAuth: true,
    roles: ['admin', 'user'],
    title: 'Chỉnh sửa playlist',
  },
  {
    path: '/schedules',
    element: Schedules,
    requiresAuth: true,
    roles: ['admin', 'user'],
    title: 'Lịch trình',
  },
  {
    path: '/users',
    element: Users,
    requiresAuth: true,
    roles: ['admin'], // Only admin can access
    title: 'Quản lý người dùng',
  },
  {
    path: '/settings',
    element: lazy(() => import('../pages/settings')),
    requiresAuth: true,
    roles: ['admin', 'user'],
    title: 'Cài đặt',
  },
  {
    path: '/profile',
    element: () => <div>Profile - Đang phát triển</div>,
    requiresAuth: true,
    roles: ['admin', 'user'],
    title: 'Hồ sơ cá nhân',
  },
];

// Get routes by type
export const getPublicRoutes = () => routes.filter(route => route.isPublic);
export const getProtectedRoutes = () => routes.filter(route => route.requiresAuth);
export const getRouteByPath = (path) => routes.find(route => route.path === path);

export default routes; 